module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.4b6a3452.svg";